/** Shim — the voice engine is served from @bod.ee/voice (extracted from here).
 *  Routes the extracted core's logs into agentx's libx.js logger. */
import { configureLogging } from '@bod.ee/voice';
import { forComponent } from '../logging';

configureLogging((name) => {
  // libx.js log methods are fixed-arity in the type surface; cast to a rest
  // signature so forwarding a spread is legal under agentx's dts build.
  const l = forComponent(name) as unknown as Record<string, (...a: unknown[]) => void>;
  const at = (m: string) => (...a: unknown[]) => l[m]?.(...a);
  return { debug: at('debug'), verbose: at('verbose'), info: at('info'), warn: at('warn'), error: at('error') };
});

export * from '@bod.ee/voice';
